"use client";

import { Container } from "@/components/ui/Container";
import { Region, LOGOS } from "../Header";
import { Divider } from "@/components/ui/Divider";
import clsx from "clsx";
import { Row } from "@/components";
import { WithVariant } from "@/types/variant";

export type HeaderTopBannerProps = WithVariant<{
  asLink?: "a" | React.ComponentType<any>;
  shortTitle: React.ReactNode;
  region?: Region;
  className?: string;
}>;

export const HeaderTopBanner = ({
  asLink = "a",
  shortTitle,
  region = "marche",
  className,
  variant = "default",
}: HeaderTopBannerProps) => {
  const LinkComponent = asLink;

  const NationalIcon = LOGOS["nazionale"];
  const RegionIcon = LOGOS[region];

  return (
    <div
      className={clsx(
        variant === "operator" ? "header-top-banner" : "",
        "bg-white",
      )}
    >
      <Container
        className={clsx("min-h-x48 base-row align-items-center", className)}
        display="flex"
        alignItems="center"
        gap="x16"
        py="x8"
      >
        <Row alignItems={"center"} gap={"x8"}>
          <NationalIcon width={28} height={28} />

          {region !== "nazionale" && (
            <>
              <Divider direction="vertical" bg="border-divider" />
              <RegionIcon width={28} height={28} />
            </>
          )}
        </Row>

        <LinkComponent
          href="/"
          className={
            "fs-7 text-decoration-none text-slate-20 fw-regular d-block hover-underline"
          }
        >
          {shortTitle}
        </LinkComponent>
      </Container>
    </div>
  );
};
